export const GOVGR_TABS__PANEL = "govgr-tabs__panel";
export const GOVGR_TABS__PANEL_VISIBLE = "govgr-tabs__panel-visible";
export const GOVGR_TABS = "govgr-tabs";
export const GOVGR_TABS__LIST_ITEM = "govgr-tabs__list-item";
export const GOVGR_TABS__LIST_ITEM_SELECTED = "govgr-tabs__list-item-selected";
export const GOVGR_TABS__TAB = "govgr-tabs__tab";
export const GOVGR_TABS__LIST = "govgr-tabs__list";
